import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fafdfe' },
    '2': { value: '#f2fafb' },
    '3': { value: '#def7f9' },
    '4': { value: '#caf1f6' },
    '5': { value: '#b5e9f0' },
    '6': { value: '#9ddde7' },
    '7': { value: '#7dcedc' },
    '8': { value: '#3db9cf' },
    '9': { value: '#00a2c7' },
    '10': { value: '#0797b9' },
    '11': { value: '#107d98' },
    '12': { value: '#0d3c48' },
    a1: { value: '#0099cc05' },
    a2: { value: '#009db10d' },
    a3: { value: '#00c2d121' },
    a4: { value: '#00bcd435' },
    a5: { value: '#01b4cc4a' },
    a6: { value: '#00a7c162' },
    a7: { value: '#009fbb82' },
    a8: { value: '#00a3c0c2' },
    a9: { value: '#00a2c7' },
    a10: { value: '#0094b7f8' },
    a11: { value: '#007491ef' },
    a12: { value: '#00323ef2' },
  },
  dark: {
    '1': { value: '#0b161a' },
    '2': { value: '#101b20' },
    '3': { value: '#082c36' },
    '4': { value: '#003848' },
    '5': { value: '#004558' },
    '6': { value: '#045468' },
    '7': { value: '#12677e' },
    '8': { value: '#11809c' },
    '9': { value: '#00a2c7' },
    '10': { value: '#23afd0' },
    '11': { value: '#4ccce6' },
    '12': { value: '#b6ecf7' },
    a1: { value: '#0091f70a' },
    a2: { value: '#02a7f211' },
    a3: { value: '#00befd28' },
    a4: { value: '#00baff3b' },
    a5: { value: '#00befd4d' },
    a6: { value: '#00c7fd5e' },
    a7: { value: '#14cdff75' },
    a8: { value: '#11cfff95' },
    a9: { value: '#00cfffc3' },
    a10: { value: '#28d6ffcd' },
    a11: { value: '#52e1fee5' },
    a12: { value: '#bbf3fef7' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.cyan.light.1}', _dark: '{colors.cyan.dark.1}' } },
  '2': { value: { _light: '{colors.cyan.light.2}', _dark: '{colors.cyan.dark.2}' } },
  '3': { value: { _light: '{colors.cyan.light.3}', _dark: '{colors.cyan.dark.3}' } },
  '4': { value: { _light: '{colors.cyan.light.4}', _dark: '{colors.cyan.dark.4}' } },
  '5': { value: { _light: '{colors.cyan.light.5}', _dark: '{colors.cyan.dark.5}' } },
  '6': { value: { _light: '{colors.cyan.light.6}', _dark: '{colors.cyan.dark.6}' } },
  '7': { value: { _light: '{colors.cyan.light.7}', _dark: '{colors.cyan.dark.7}' } },
  '8': { value: { _light: '{colors.cyan.light.8}', _dark: '{colors.cyan.dark.8}' } },
  '9': { value: { _light: '{colors.cyan.light.9}', _dark: '{colors.cyan.dark.9}' } },
  '10': { value: { _light: '{colors.cyan.light.10}', _dark: '{colors.cyan.dark.10}' } },
  '11': { value: { _light: '{colors.cyan.light.11}', _dark: '{colors.cyan.dark.11}' } },
  '12': { value: { _light: '{colors.cyan.light.12}', _dark: '{colors.cyan.dark.12}' } },
  a1: { value: { _light: '{colors.cyan.light.a1}', _dark: '{colors.cyan.dark.a1}' } },
  a2: { value: { _light: '{colors.cyan.light.a2}', _dark: '{colors.cyan.dark.a2}' } },
  a3: { value: { _light: '{colors.cyan.light.a3}', _dark: '{colors.cyan.dark.a3}' } },
  a4: { value: { _light: '{colors.cyan.light.a4}', _dark: '{colors.cyan.dark.a4}' } },
  a5: { value: { _light: '{colors.cyan.light.a5}', _dark: '{colors.cyan.dark.a5}' } },
  a6: { value: { _light: '{colors.cyan.light.a6}', _dark: '{colors.cyan.dark.a6}' } },
  a7: { value: { _light: '{colors.cyan.light.a7}', _dark: '{colors.cyan.dark.a7}' } },
  a8: { value: { _light: '{colors.cyan.light.a8}', _dark: '{colors.cyan.dark.a8}' } },
  a9: { value: { _light: '{colors.cyan.light.a9}', _dark: '{colors.cyan.dark.a9}' } },
  a10: { value: { _light: '{colors.cyan.light.a10}', _dark: '{colors.cyan.dark.a10}' } },
  a11: { value: { _light: '{colors.cyan.light.a11}', _dark: '{colors.cyan.dark.a11}' } },
  a12: { value: { _light: '{colors.cyan.light.a12}', _dark: '{colors.cyan.dark.a12}' } },
  default: { value: { _light: '{colors.cyan.light.9}', _dark: '{colors.cyan.dark.9}' } },
  emphasized: { value: { _light: '{colors.cyan.light.10}', _dark: '{colors.cyan.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.cyan.light.a11}', _dark: '{colors.cyan.dark.a11}' } },
})

export default {
  name: 'cyan',
  tokens,
  semanticTokens,
}
